import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listAlluraDirectImage, listWhistlerLogo, whistlerBlackombLogo, partnerQuestionLogo } from 'config/imageUrls';

import { ContentSection } from './styles';

const partnerDetails = [
  {
    imageUrl: listAlluraDirectImage,
    title: 'alluraDirect.com',
    body:
      'Invite guests from around the world to experience your property by using one of the original hosting platforms on the Internet.',
  },
  {
    imageUrl: listWhistlerLogo,
    title: 'Whistler.com',
    body:
      'All Tourism Whistler members in good standing are eligible to be listed on Whistler.com, the offical resort reservations service.  Profits are reinvested into marketing the resort as a whole, improving sustainability of the community.',
  },
  {
    imageUrl: whistlerBlackombLogo,
    title: 'WhistlerBlackcomb.com',
    body:
      'Advertise your property on the official mountain (Vail Resorts) website where guests from around the world come to experience.',
  },
  {
    imageUrl: partnerQuestionLogo,
    title: 'Other Mountain Partners',
    body:
      'We are actively building relationships with ski resort destinations in British Columbia and in Canada. To further these partnerships and opportunities, we need as many rental properties in each location as possible - help us build each community by listing today.',
  },
];
const MarketingPartnerItem = ({ imageUrl, title, body }: { imageUrl: string; title: string; body: string }) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={2} align="center">
        <img src={imageUrl} width="100%" style={{ maxWidth: '400px' }} />
      </Grid>

      <Grid item xs={12} sm={10}>
        <Typography variant="h3">{title}</Typography>
        <Typography>{body}</Typography>
      </Grid>
    </Grid>
  );
};

export const MarketingPartners = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h2" mb={2}>
              Marketing &amp; Local Partners
            </Typography>
            <Typography mb={1}>
              Since 1997, alluraDirect has been the booking source for hundreds-of-thousands of guests who have enjoyed
              a mountain vacation getaway in Whistler, Big White and Sun Peaks. As the popularity of vacation rentals
              increase, so does the opportunity to partner with local business and the resort destinations directly.
            </Typography>
            <Typography mb={4}>
              Every rental property listed is important and helps develop and strengthen the communities for long-term
              success.
            </Typography>
          </Grid>
          {partnerDetails.map((partner, index) => (
            <Grid item xs={12} key={partner.title + index}>
              <MarketingPartnerItem {...partner} />
            </Grid>
          ))}
        </Grid>
      </ContentSection>
    </>
  );
};
